import { useStore } from 'hooks/useStore';
import { observer } from 'mobx-react';
import { Dialog } from 'primereact/dialog';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useBulkUpdate } from './useBulkUpdate';
import ConceptListSection from './components/ConceptListSection';
import classes from './conceptList.module.scss';

const BulkUpdateModal = () => {
  const {
    UnconstrainedForecastViewStore: {
      isBulkUpdateModalOpen,
      toggleBulkUpdateModal,
      isUnconstrainedForecastProgressLoading,
    },
  } = useStore();
  const {
    bulkUpdateDirectTodoNDC,
    bulkUpdateDirectCompletedNDC,
    bulkUpdateIndirectTodoNDC,
    bulkUpdateIndirectCompletedNDC,
  } = useBulkUpdate();

  return (
    <Dialog
      draggable={false}
      resizable={false}
      visible={isBulkUpdateModalOpen}
      onHide={() => {
        if (!isBulkUpdateModalOpen) return;
        toggleBulkUpdateModal();
      }}
      header={<span style={{ color: 'var(--text-primary)' }}>Bulk Update Unconstrained Forecast</span>}
      style={{
        width: '80vw',
      }}
    >
      {isUnconstrainedForecastProgressLoading ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '20rem',
          }}
        >
          <ProgressSpinner style={{ width: '60px', height: '60px' }} strokeWidth="4" animationDuration="1s" />
        </div>
      ) : (
        <div className={classes.conceptListContainer}>
          <ConceptListSection
            heading="To Do"
            directData={bulkUpdateDirectTodoNDC}
            indirectData={bulkUpdateIndirectTodoNDC}
          />
          <ConceptListSection
            heading="Completed"
            directData={bulkUpdateDirectCompletedNDC}
            indirectData={bulkUpdateIndirectCompletedNDC}
          />
        </div>
      )}
    </Dialog>
  );
};

export default observer(BulkUpdateModal);
